import Swiper from 'swiper';

export default {
  init() {
    //sliders
    // eslint-disable-next-line
    var animationSliderInit = new Swiper('.animation-slider-init', {
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
      },
      pagination: {
        clickable: true,
        el: '.animation-gallery-pagination',
      },
    });
    new Swiper('.event-slider-init', {
      slidesPerView: 1,
      spaceBetween: 25,
      loop: true,
      pagination: {
        clickable: true,
        el: '.swiper-event-pagination',
      },
      breakpoints: {
        575: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 25,
        },
        1374: {
          slidesPerView: 4,
          spaceBetween: 25,
        },
      },
    });
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};
